var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-hub"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2213 0.84375H16.9803L10.9224 7.76605L18 17.1562H12.4458L8.0973 11.4499L3.11896 17.1562H0.359883L6.77774 9.75246L0 0.84375H5.6921L9.62082 6.05653L14.2213 0.84375ZM13.2556 15.531H14.7851L4.88837 2.40879H3.24491L13.2556 15.531Z",
    fill: "#767A7F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTwitter);
export default __webpack_public_path__ + "static/media/icn_twitter.55e191421ea5f5445eb419ebc2cfbb9e.svg";
export { ForwardRef as ReactComponent };